import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import MainLayout from "./components/layout/MainLayout";
import ExpansionPage from "./pages/ExpansionPage";
import TrackingPage from "./pages/TrackingPage";
import ReportsPage from "./pages/ReportsPage";
import PlanningPage from "./pages/PlanningPage";
import Login from "./pages/Login";
import RoleSelector from "./pages/RoleSelector";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ActiveRoleProvider, useActiveRole } from "./context/ActiveRoleContext";
import { ExpansionProvider } from "./context/ExpansionContext";

// Blocks private routes when no token is present, and when no role has been chosen yet: las
// vistas dependen del rol activo (que lineas se ven), asi que entrar sin elegirlo no es un estado
// valido. Un refresh no molesta — el rol activo se persiste en localStorage.
const ProtectedRoute = ({ children }) => {
  const { token } = useAuth();
  const { activeRoleId } = useActiveRole();
  if (!token && !localStorage.getItem("token")) {
    return <Navigate to="/login" replace />;
  }
  if (activeRoleId === null) {
    return <Navigate to="/select-role" replace />;
  }
  return children;
};

// Blocks login when user is already authenticated
const PublicRoute = ({ children }) => {
  const { token } = useAuth();
  if (token || localStorage.getItem("token")) {
    return <Navigate to="/tracking" replace />;
  }
  return children;
};

// El selector necesita sesion, pero NO rol activo (es justo lo que viene a elegir).
const AuthenticatedRoute = ({ children }) => {
  const { token } = useAuth();
  if (!token && !localStorage.getItem("token")) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

function App() {
  return (
    <ActiveRoleProvider>
      <AuthProvider>
        <ExpansionProvider>
          <BrowserRouter>
            <Routes>
              {/* RUTA PÚBLICA (Protegida para que no vuelvan al login si ya entraron) */}
              <Route path="/login" element={
                <PublicRoute>
                  <Login />
                </PublicRoute>
              } />

              {/* SELECCIÓN DE ROL: con sesión abierta pero sin rol elegido */}
              <Route path="/select-role" element={
                <AuthenticatedRoute>
                  <RoleSelector />
                </AuthenticatedRoute>
              } />

              {/* RUTAS PRIVADAS */}
              <Route path="/" element={
                <ProtectedRoute>
                  <MainLayout />
                </ProtectedRoute>
              }>
                <Route index element={<Navigate to="/tracking" replace />} />
                <Route path="tracking" element={<TrackingPage />} />
                <Route path="planning" element={<PlanningPage />} />
                <Route path="expansion" element={<ExpansionPage />} />
                <Route path="reports" element={<ReportsPage />} />
              </Route>

              {/* Redirección por defecto si la ruta no existe */}
              <Route path="*" element={<Navigate to="/tracking" replace />} />
            </Routes>
          </BrowserRouter>
        </ExpansionProvider>
      </AuthProvider>
    </ActiveRoleProvider>
  );
}

export default App;
